import Header from "./components/Header";
import Todo from "./components/Todo";

function App() {
  return (
    <div className="container">
      <Header />
      <Todo />
    </div>
  );
}

export default App;
